import PreloadView from "../../../vendor_core/core/src/views/PreloadView";
import CommandManager from "../../core/src/commands/CommandManager";
import { VendorCommandsEnum } from "../commands/VendorCommandsEnum";


export default class VendorPreloadView extends PreloadView {
    constructor() {
        super();
    }

    protected setProgress(progress: number): void {
        super.setProgress(progress);
        CommandManager.execute(
            VendorCommandsEnum.GAME_LOAD_PROGRESS,
            progress * 100
        );
    }
}